class CartWatcherCustom {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges();
    });
  }

  async fetchCart() {
    const response = await fetch('/cart.js');
    return response.json();
  }

  storeCart(cart) {
    localStorage.setItem('cart', JSON.stringify(cart));
  }

 storedCart() {
    return JSON.parse(localStorage.getItem('cart')) || { items: [] };
  }

 findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) => l.filter(li => !r.some(ri => li.key == ri.key));
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items),
    };

    oldCart.items.forEach(oi => {
      const ni = newCart.items.find(i => i.key == oi.key && i.quantity != oi.quantity);
      if (!ni) return;
      let quantity = ni.quantity - oi.quantity;
      let item = { ...ni };
      item.quantity = Math.abs(quantity);
      quantity > 0
        ? result.added.push(item)
        : result.removed.push(item)
    });

    return result;
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart();
    const oldCart = this.storedCart();
    const changes = this.findCartChanges(oldCart, newCart);

    const event = new CustomEvent("cart_changed", { detail: changes });
    window.dispatchEvent(event);

    this.storeCart(newCart);
  }

 observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(entry.initiatorType);
        const isCartChangeRequest = /\/cart\//.test(entry.name);
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges();
        }
      });
    });
    cartObserver.observe({ entryTypes: ["resource"] });
  }
}

const myCartWatcher = new CartWatcherCustom;
myCartWatcher.init();

window.addEventListener("cart_changed", e => {
  if(e.detail.removed.length > 0){
    let all_item = document.querySelectorAll('#cart .js-contents .cart-item');
    if(all_item.length > 0){
      const target_class = 'cart-item__is-upsell';
      const items_with_Class = Array.from(all_item).filter(item => item.classList.contains(target_class));
      if (items_with_Class.length === all_item.length) {
        all_item.forEach(product_node =>{
          let btn_remove = document.querySelector('.cart-item__quantity cart-remove-button .button');
          if (btn_remove) {
            btn_remove.click();
          }
        });
      }
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  console.log('Product links:', document.querySelectorAll('#Slider-template--23471857369424__featured_collection_YCTAme a.full-unstyled-link').length);
  console.log('Card links:', document.querySelectorAll('.card-wrapper .full-unstyled-link').length);
  console.log('Rose links:', document.querySelectorAll('.rose-links .rose-link').length);
  // Scroll for Media Gallery section
  if (sessionStorage.getItem('scrollToMediaGallery') === 'true') {
    sessionStorage.removeItem('scrollToMediaGallery');
    scrollToTarget('MediaGallery-template--23471857369424__main', 75);
  }

  // Scroll for card section (example)
  if (sessionStorage.getItem('scrollToCard') === 'true') {
    sessionStorage.removeItem('scrollToCard');
    scrollToTarget('CardSectionTargetID', 75);
  }

  // Scroll for rose section (example)
  if (sessionStorage.getItem('scrollToRoseSection') === 'true') {
    sessionStorage.removeItem('scrollToRoseSection');
    scrollToTarget('RoseSectionTargetID', 75);
  }

  // A utility function to perform the scroll
  function scrollToTarget(targetId, offset) {
    const target = document.getElementById(targetId);
    if (target) {
      setTimeout(() => {
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      }, 100);
    }
  }

  // Attach event listeners for the product links in the slider
  const productLinks = document.querySelectorAll('#Slider-template--23471857369424__featured_collection_YCTAme a.full-unstyled-link');
  productLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetHref = this.getAttribute('href');
      // Set a flag so that the new page scrolls after loading
      sessionStorage.setItem('scrollToMediaGallery', 'true');
      window.location.href = targetHref;
    });
  });

  // Attach event listeners for the card links
  const cardLinks = document.querySelectorAll('.card-wrapper .full-unstyled-link');
  cardLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetHref = this.getAttribute('href');
      sessionStorage.setItem('scrollToMediaGallery', 'true');
      window.location.href = targetHref;
    });
  });

  // For rose links 
  const roseLinks = document.querySelectorAll('.rose-links .rose-link');
  roseLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const targetHref = this.getAttribute('href');
      sessionStorage.setItem('scrollToMediaGallery', 'true');
      window.location.href = targetHref;
    });
  });
});